import { createSelector } from '@reduxjs/toolkit';
import { personalDataItemsNotDeleted } from './personal-data-items-not-deleted';
import { getOrganization } from '../organization/getOrganization';
import type { ComputerViewModel, PersonalDataItemViewModel } from '@trinnvis/dabih-api-client';
import type { PersonalDataItemViewModelExtended } from './personal-data-item-view-model-extended';
import { alertsForDataItem } from './alerts-for-data-item';
import { firstBy } from 'thenby';

export const personalDataItemTypeInSortOrder = [
  'medicalRecords',
  'medicalEquipmentRecords',
  'patientDialogue',
  'employeeRecords',
  'customerRecords',
  'OTHER',
  'UNDEFINED',
];

type SortablePersonalDataItem = {
  name?: string;
  uuid: string;
  type?: string;
};

export const personalDataItemsForMap = createSelector(
  personalDataItemsNotDeleted,
  getOrganization,
  function (
    items,
    organization,
  ): (PersonalDataItemViewModel & {
    storageUnitComputer: ComputerViewModel | undefined;
  } & {
    alerts: string[];
  })[] {
    if (organization === undefined) return [];
    const itemsWithComputers = items as unknown as PersonalDataItemViewModelExtended[];
    const map = itemsWithComputers
      .map((c) => {
        return {
          ...c,
          storageUnitComputer: c.storageUnit !== undefined ? organization.computersById[c.storageUnit] : undefined,
        };
      })
      .map((c) => {
        return {
          ...c,
          alerts: alertsForDataItem(c),
        };
      });
    return map.sort(
      firstBy<SortablePersonalDataItem>(function (v) {
        return personalDataItemTypeInSortOrder.indexOf(v.type ?? 'UNDEFINED');
      })
        .thenBy('name', { ignoreCase: true })
        .thenBy('uuid'),
    );
  },
);
